export const select = Symbol('select');
export const selectNext = Symbol('next');
export const selectPrev = Symbol('prev');
export const isActive = Symbol('isActive');
export const isRegisteredTab = Symbol('isRegisteredTab');
export const addTab = Symbol('addTab');
export const removeTab = Symbol('removeTab');
